
import {
  computed,
  defineComponent,
  reactive,
} from 'vue';

import LazyBackgroundMedia from '@/components/LazyBackgroundMedia.vue';
import Expansion from '@/components/Expansion.vue';

export default defineComponent({
  components: {
    LazyBackgroundMedia,
    Expansion,
  },
  props: {
    mediaId: {
      type: String,
      required: false,
      default: () => '0',
    },
    mediaSizes: {
      type: String,
      required: false,
      default: () => btoa('null'),
    },
    buttonType: {
      type: String,
      required: false,
      default: () => 'button',
    },
    textAlign: {
      type: String,
      required: false,
      default: () => 'center',
    },
    icon: {
      type: String,
      required: false,
      default: () => 'far fa-chevron-right',
    },
    expanded: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },
  setup(props) {
    const hasMedia = props.mediaId !== '0';

    const component = reactive({
      expanded: props.expanded,
    });

    const classes = computed(() => {
      const cardClasses = [];

      cardClasses.push(`text-${props.textAlign}`);

      if (component.expanded) {
        cardClasses.push('expanded');
      }

      return cardClasses;
    });

    const toggle = (e: MouseEvent) => {
      e.preventDefault();

      component.expanded = !component.expanded;
    };

    return {
      hasMedia,
      classes,
      component,
      toggle,
    };
  },
});
